import { render, staticRenderFns } from "./GraficoCrescimento.vue?vue&type=template&id=c3ae9b98&"
import script from "./GraficoCrescimento.vue?vue&type=script&lang=js&"
export * from "./GraficoCrescimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports